import {combineReducers} from "redux";
// import {routerReducer} from "connected-react-router";
import { connectRouter } from 'connected-react-router'
import Settings from "./Settings";
import Auth from "./Auth";
import Notes from "./Notes";
import Contact from "./Contact";
import Common from "./Common";
import Application from "./Application";
import Device from "./Device";
import Minisite from "./Minisite";
import MinisiteEditor from "./MinisiteEditor";
import Logs from "./Logs";
import Zone from "./Zone";
import UserPoolClient from "./UserPoolClient";
import DeviceBatch from "./DeviceBatch";
import MeshNetwork from "./MeshNetwork";
import Websocket from "./Websocket";

const reducers = (history) => combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  notes: Notes,
  contact: Contact,
  common: Common,
  application: Application,
  device: Device,
  minisite: Minisite,
  minisiteEditor: MinisiteEditor,
  logs: Logs,
  zone: Zone,
  userPoolClient: UserPoolClient,
  deviceBatch: DeviceBatch,
  meshNetwork: MeshNetwork,
  websocket: Websocket
});

export default reducers;
